import { Box, Slide } from '@mui/material';
import React from 'react';
import { globalHeaderHeightNormal, globalHeaderHeightSmall } from '../GlobalHeader/constants';
import { themeColors } from '../JuvareTheme';
/**
 * A slideout drawer component that supports both full-screen and fixed-width modes.
 * It animates its entry and exit using Material UI's `<Slide />` transition component.
 *
 * @param {GlobalDrawerSlideoutProps} root0 - Props for the slideout drawer.
 * @param {boolean} root0.drawerOpen - Determines if the drawer is currently open.
 * @param {boolean} root0.isDrawerInFullScreen - Whether the drawer should occupy the entire viewport.
 * @param {number} root0.drawerWidth - The width of the drawer in pixels (used when not in full-screen).
 * @param {React.ReactNode} root0.children - The content to be rendered inside the drawer.
 *
 * @returns {JSX.Element} The animated drawer component.
 */
export const GlobalDrawerSlideout = ({ children, drawerOpen, isDrawerInFullScreen, drawerWidth }) => {
    const [isDrawerOpenAsync, setIsDrawerOpenAsync] = React.useState(drawerOpen);
    return (React.createElement(Slide, { in: drawerOpen, timeout: 400, direction: 'left', mountOnEnter: true, unmountOnExit: true, onExited: () => setIsDrawerOpenAsync(drawerOpen), onEntered: () => setIsDrawerOpenAsync(drawerOpen) },
        React.createElement(Box, { sx: Object.assign({ backgroundColor: themeColors.overlay.primary, overflow: 'hidden', right: 0, bottom: 0, position: 'fixed', boxShadow: (theme) => theme.shadows[4] }, (isDrawerInFullScreen
                ? {
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    zIndex: (theme) => theme.zIndex.drawer,
                }
                : {
                    top: { xs: globalHeaderHeightSmall + 'px', sm: globalHeaderHeightNormal + 'px' },
                    width: `${drawerWidth}px`,
                    height: 'calc(100vh - 64px)',
                    zIndex: (theme) => theme.zIndex.appBar - 1,
                })), role: 'dialog', "aria-modal": 'true', "aria-hidden": !isDrawerOpenAsync }, children)));
};
